import visaLogo from "assets/card-icons/Visa-op.svg";
import mastercardLogo from "assets/card-icons/Mastercard-op.svg";
import unionpayLogo from "assets/card-icons/Unionpay-op.svg";
import amexLogo from "assets/card-icons/Amex_rec-op.svg";
import alipayLogo from "assets/card-icons/Alipay-op.svg";
import wechatpayLogo from "assets/card-icons/wechat-op.svg";
import jcbLogo from "assets/card-icons/JCB-op.svg";
import fpsLogo from "assets/card-icons/FPS-op.svg";
import octopusLogo from "assets/card-icons/Octopus-op.svg";
import applePayLogo from "assets/card-icons/Apple_Pay-op.svg";
import googlePayLogo from "assets/card-icons/GPay-op.svg";
import unionpayQuickpassLogo from "assets/card-icons/Upi-qrcode-op.svg";
import payme from "assets/card-icons/Payme-op.svg";
import unknownCardLogo from "assets/card-icons/unknown-type-op.svg";
import cc from "currency-codes";
import moment from "moment";

export const amountConversion = (number) => {
  if (isNaN(number)) {
    return number;
  }
  const regex = /\B(?=(\d{3})+(?!\d))/g;
  const numArr = number.toString().split(".");
  const decimal = numArr.length === 2 ? ".".concat(numArr[1]) : null;
  return `${numArr[0].replace(regex, ",")}${decimal ?? ""}`;
};

export const onlyNumberAccept = (string) => {
  return string.replace(/[^0-9]/g, "");
};

export const sortArray = (array) => {
  return array.sort((a, b) => {
    return a.index - b.index;
  });
};

export const trimObject = (obj) => {
  const trimObject = obj;
  Object.keys(trimObject).map((key) => {
    if (
      trimObject[key] === "" ||
      trimObject[key] == undefined ||
      trimObject[key] == null
    ) {
      delete trimObject[key];
    }
  });
  return trimObject;
};

export const getAgent = () => {
  const session = localStorage.getItem("session");
  let isoAgent;
  if (session) {
    isoAgent = JSON.parse(session).isoAgent;
    return isoAgent;
  }
  return null;
};

export const findObjInArray = (array, targetObj) => {
  const result = array.some(
    (obj) => JSON.stringify(obj) === JSON.stringify(targetObj),
  );
  if (!result) {
    return { result };
  }
  const index = array.findIndex(
    (obj) => JSON.stringify(obj) === JSON.stringify(targetObj),
  );
  return { result, index };
};

export const isCurrencyShouldBeInteger = (countryCode) => {
  let shouldBeInteger = false;
  const parsedCountryCode =
    typeof countryCode === "string"
      ? countryCode
      : cc.number(countryCode)?.code;
  if (
    parsedCountryCode === "JPY" ||
    parsedCountryCode === "VND" ||
    parsedCountryCode === "KRW"
  ) {
    shouldBeInteger = true;
  }
  return shouldBeInteger;
};

export const checkNonMoneyDataForTable = (data, key) => {
  if (!data[key]) {
    return "-";
  }
  return data[key];
};

export const checkMoneyDataForTable = (data, key, currencyKey) => {
  if (
    (currencyKey
      ? isCurrencyShouldBeInteger(data[currencyKey])
      : isCurrencyShouldBeInteger(data.currency)) ||
    isCurrencyShouldBeInteger(data.currencyCode)
  ) {
    return data[key] ? amountConversion(data[key]) : "0";
  }
  return data[key] ? amountConversion(Number(data[key]).toFixed(2)) : "0.00";
};

export const checkMoneyDataForSummaryTable = (data, currency) => {
  if (isCurrencyShouldBeInteger(currency)) {
    return data ? amountConversion(data) : "0";
  }
  return data ? amountConversion(Number(data).toFixed(2)) : "0.00";
};

export const isNullish = (value) => {
  if (value === null || value === undefined) return true;
  return false;
};

export const getCardTypeIcon = (cardType) => {
  const paymentType = cardType?.toLowerCase?.();
  const logoMap = {
    visa: visaLogo,
    mastercard: mastercardLogo,
    master: mastercardLogo,
    unionpay: unionpayLogo,
    union: unionpayLogo,
    amex: amexLogo,
    alipay: alipayLogo,
    wechatpay: wechatpayLogo,
    wechat: wechatpayLogo,
    jcb: jcbLogo,
    fps: fpsLogo,
    octopus: octopusLogo,
    applepay: applePayLogo,
    googlepay: googlePayLogo,
    unionpayquickpass: unionpayQuickpassLogo,
    payme: payme,
  };
  return logoMap[paymentType] ?? unknownCardLogo;
};

export const isEmptyOrBlank = (field) => {
  return field === null || field === undefined || String(field).trim() === "";
};

export const dateFormat = (dateStr) => {
  const parsedDate = moment(dateStr);

  if (!parsedDate.isValid()) {
    return null;
  }

  return parsedDate.format("YYYY/MM/DD HH:mm:ss");
};

export const currencyMappingJson = {
  344: "HKD",
  840: "USD",
  702: "SGD",
  978: "EUR",
  392: "JPY",
  826: "GBP",
  124: "CAD",
  "036": "AUD",
  764: "THB",
  704: "VND",
  901: "TWD",
  410: "KRW",
  360: "IDR",
};

export const isPositiveInteger = (value) => {
  return /^[1-9]\d*$/.test(value);
};

export const agentTimezoneMapping = (timezone) => {
  /* MAS-349. This function is aligned OBS & OP timezones behaviour when creating and rendering agent detail. */
  if (typeof timezone !== "string" || !timezone.startsWith("Etc/GMT"))
    return "";
  return timezone.includes("-")
    ? timezone.replace("-", "+")
    : timezone.replace("+", "-");
};

export const dateTimeFormatter = (dateTime) => {
  /* MAS-345. align the date formation to YYYY-MM-DD HH:mm:ss Z*/
  const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
  if (dateTime === "-") return "-"; // this is for rendering table list. If there is no data, it will show "-" in the table.
  if (typeof dateTime !== "string" || !regex.test(dateTime)) return null;
  return moment(dateTime).format("YYYY-MM-DD HH:mm:ss Z");
};

export const strongPasswordReqObj = {
  length: /^(?=.{12,})/g,
  lowerCase: /^(?=.*[a-z])/g,
  upperCase: /^(?=.*[A-Z])/g,
  symbol:
    /^(?=.*[\$\*\+\.\?\^\`\~\!\@\#\%\&\(\)\=\_\;\:\'\"\,\<\>\/\[\{\}\|\]\\\-])/g,
  number: /^(?=.*[0-9])/g,
};

export const validateStrongPassword = (password) => {
  const passwordReqRegex = Object.values(strongPasswordReqObj);
  return (
    passwordReqRegex.reduce((acc, cur) => acc + +cur.test(password), 0) ===
    passwordReqRegex.length
  );
};

export const hasPassedNextDayMidnight = (datetime) => {
  const transactionTime = moment(datetime);
  if (!transactionTime.isValid()) {
    return false;
  }
  const nextMidnight = transactionTime.clone().add(1, "days").startOf("day");
  return moment().isSameOrAfter(nextMidnight);
};

export const ProcessorType = {
  ALLINPAY: "ALLINPAY",
  FUBON: "FUBON",
  YEDPAY: "YEDPAY",
  ALIPAY: "ALIPAY",
  WECHAT_PAY: "WECHAT_PAY",
  HSBC: "HSBC",
  AMEX: "AMEX",
  AMEX_BBMSL: "AMEX_BBMSL",
  OCTOPUS_HKBN: "OCTOPUS_HKBN",
  OCTOPUS: "OCTOPUS",
  OCTOPUS_BBMSL: "OCTOPUS_BBMSL",
  GLOBALPAYMENTS: "GLOBALPAYMENTS",
  DBS: "DBS",
  DSB: "DSB",
  NONE: "NONE"
};
